// Composables
import { useAuth } from '~/modules/auth/composables/use-auth';
import { useAuthMiddleware } from '~/misc/auth/composables/use-auth-middleware';
import { useAfterClientLoginRedirectRoute } from '~/modules/auth/composables/use-after-login-redirect-route';

const AUTH_PATHS: string[] = ['login', 'login-passcode', 'register', 'register-passcode', 'reapit'];

export default defineNuxtRouteMiddleware((_to, _from) => {
  const { store, terminate } = useAuth();
  const { set: setAfterLoginRedirectRoute } = useAfterClientLoginRedirectRoute();

  // Logout current user when visiting login link to allow logging in as a different user
  if (store.token && _to.name === 'login-passcode') {
    terminate();

    return;
  }

  const { handle } = useAuthMiddleware(
    store,
    terminate,
    AUTH_PATHS,
    '/',
    '/login',
    setAfterLoginRedirectRoute
  );

  return handle(_to, _from);
});
